import * as yup from 'yup';

export const feedbackSchema = yup.object().shape({
  category: yup.string().required().notOneOf(['0']),
  content: yup.string().required(),
});
